export const GETTER_TYPES = {
	CAMPAIGN_IDENTIFIER: 'campaignIdentifier',
	CAMPAIGN: 'campaign',
	CATEGORIES: 'categories',
	BRANDS: 'brands',
	MODELS: 'models',
	COLORS: 'colors',
	GET_SELECTED_CATEGORY: 'getSelectedCategory',
	GET_SELECTED_BRAND: 'getSelectedBrand',
	GET_SELECTED_MODEL: 'getSelectedModel',
	GET_SELECTED_COLOR: 'getSelectedColor',
	LOADING_CATEGORIES: 'loadingCategories',
	LOADING_BRANDS: 'loadingBrands',
	LOADING_MODELS: 'loadingModels',
	LOADING_COLORS: 'loadingColors',
	GENDERS: 'genders',
	STATES: 'states',
	CONTRACT_FORM: 'contractForm',
	QUALITIES: 'qualities',
	QUALITY_TYPES: 'qualityTypes',
	SELECTED_QUALITY: 'selectedQuality',
	APPRAISAL: 'appraisal',
	USER_BUYOUT_CODE: 'userBuyoutCode',
	CAN_NOT_BE_BUYOUT: 'canNotBeBuyout',
	DISPLAY_THANK_YOU: 'displayThankYou',
	IS_APPRAISAL_EDITABLE: 'isAppraisalEditable',
	APPRAISAL_ERRORS: 'appraisalErrors',
	APPRAISAL_RESULTS: 'appraisalResults',
	APPRAISAL_LOAD_ERROR: 'appraisalLoadError',
	DEFAULT_QUALITY_CONDITIONS: 'defaultQualityConditions',
	BUYOUT_BONUSES: 'buyoutBonuses',
	IS_PRE_SALE_INFO: 'isPreSaleInfo',
	IS_BUYOUT_ONLINE: 'isBuyoutOnline',
	PRESALE_INFO_EMAIL: 'presaleInfoEmail',
	BUYOUT_LOAD_ERROR: 'buyoutLoadError',
	BUYOUT_STATE: 'buyoutState',
	IS_REGISTRATION: 'isRegistration',
	IS_LOGGED_IN: 'isLoggedIn',
	BONUS_TYPE: 'bonusType',
	SELECTED_BONUS: 'selectedBonus',
	BUYOUT_STATE_IDENTIFIER: 'buyoutStateIdentifier',
	IS_BUYOUT_EDITABLE: 'isBuyoutEditable',
	BUYOUT_RECEIPT: 'buyoutReceipt',
	BUYOUT_RECEIPT_ERRORS: 'buyoutReceiptErrors',
	PICKUP_ADDRESS: 'pickupAddress',
	PICKUP_ADDRESS_ERRORS: 'pickupAddressErrors',
	NEW_DEVICE_IMEI: 'newDeviceImei',
	NEW_DEVICE_IMEI_ERRORS: 'newDeviceImeiErrors',
	NEW_DEVICE_IMEI_SAVED: 'newDeviceImeiSaved',
	EDITABLE_IMEI: 'editableImei',
	DISABLE_BUYOUT_SEND_BTN: 'disableBuyoutSendBtn',
	STATE_TYPES: 'stateTypes',
	COMMON_ERROR: 'commonError',
	PARTNERS: 'partners',
	SELECTED_PARTNER: 'selectedPartner',
	CONSENT_TO_MARKETING: 'consentToMarketing',
	USABLE_BUYOUT_BONUSES: 'usableBuyoutBonuses',
	TOTAL_STEPS: 'totalSteps',
	GET_BUYOUT_PAYLOAD: 'getBuyoutPayload',
	GET_IS_DIFFERENT_PICKUP_ADDRESS: 'getDifferentPickupAddress',
	GET_SELECTED_NEW_MODEL: 'getSelectedNewModel',
	GET_SELECTED_NEW_MODEL_PARTNER: 'getSelectedNewModelPartner',
	GET_BUYOUT_APPRAISAL_RESULT_BY_ID: "getBuyoutAppraisalResultById",
	GET_TOTAL_PRICE_CORRECTION: 'getTotalPriceCorrection',
}
